// src/services/deployApi.ts
import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomBaseQuery } from "./customBaseQuery";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL!.replace(/\/$/, "");

export const deployApi = createApi({
  reducerPath: "deployApi",
  baseQuery: createCustomBaseQuery(`${API_BASE_URL}/deploy/`),
  endpoints: (builder) => ({
    // 🔹 Deploy app with dynamic version
    deployApp: builder.mutation<any, { app_project_id: string; version_id: string }>({
      query: ({ app_project_id, version_id }) => ({
        url: "dev-deploy",
        method: "POST",
        body: {
          app_project_id,
          version_id,
        },
      }),
    }),

    // 🔹 Fetch app preview (dynamic version)
    fetchAppPreview: builder.mutation<any, { app_project_id: string; version_id: string }>({
      query: ({ app_project_id, version_id }) => ({
        url: "fetch-app-preview",
        method: "POST",
        body: {
          app_project_id,
          version_id,
        },
      }),
    }),

    // 🔹 Fix app errors (dynamic version)
    fixAppErrors: builder.mutation<any,{ app_project_id: string; version_id: string; user_provided_error: string }>({
      query: ({ app_project_id, version_id, user_provided_error }) => ({
        url: "fix-app-errors",
        method: "POST",
        body: {
          app_project_id,
          version_id,
          user_provided_error,
        },
      }),
    }),

    // 🔹 Modify app code (dynamic version)
    modifyAppCode: builder.mutation<any,{ app_project_id: string; version_id: string; user_instructions: string; additional_context?: string }>({
      query: ({ app_project_id, version_id, user_instructions, additional_context }) => ({
        url: "modify-app-code",
        method: "POST",
        body: {
          app_project_id,
          version_id,
          user_instructions,
          additional_context,
        },
      }),
    }),

    // 🔹 Manual file update (dynamic version)
    manualFileUpdate: builder.mutation<any,{ app_project_id: string; version_id: string; manual_file_updates: { filename: string; content: string }[] }>({
      query: ({ app_project_id, version_id, manual_file_updates }) => ({
        url: "manual-changes",
        method: "POST",
        body: {
          app_project_id,
          version_id,
          manual_file_updates,
        },
      }),
    }),
  }),
});

export const {
  useDeployAppMutation,
  useFetchAppPreviewMutation,
  useFixAppErrorsMutation,
  useModifyAppCodeMutation,
  useManualFileUpdateMutation,
} = deployApi;
